import { render, staticRenderFns } from "./wizard_header.html?vue&type=template&id=3f33a742&external"
import script from "./wizard_header.vue?vue&type=script&lang=js"
export * from "./wizard_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports